import { render } from "./seating.vue?vue&type=template&id=af49d8b6&scoped=true"
import script from "./seating.vue?vue&type=script&lang=js"
export * from "./seating.vue?vue&type=script&lang=js"

import "./seating.vue?vue&type=style&index=0&id=af49d8b6&scoped=true&lang=css"
import "./seating.vue?vue&type=style&index=1&id=af49d8b6&lang=css"
script.render = render
script.__scopeId = "data-v-af49d8b6"

export default script